import React from 'react';

import { InteractionOverlaySettings } from '$/GraphQL/schema/types';
import { InteractionInfo, OverlayDimensions } from '$/components/Interactions/InteractionInfo';
import { useWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { useHasChangedDeep } from './useHasChanged';

export function useOverlayDimensions(
  interaction: InteractionInfo,
  settings?: InteractionOverlaySettings | null
): OverlayDimensions {
  if (!settings) {
    settings = interaction.overlaySettings();
  }

  const { dimensions } = useWebinarPlayerContext();
  const { changeVersion: version } = useHasChangedDeep([settings]);

  const ovDimensions = React.useMemo(() => {
    version;

    return interaction.calcOverlayDimensionsHook()(
      interaction,
      dimensions.videoStage.width,
      dimensions.videoStage.height,
      settings
    );
  }, [interaction, dimensions.videoStage.width, dimensions.videoStage.height, settings, version]);

  return ovDimensions;
}
